import styled from 'styled-components';

export const ModalTitle = styled.h1`
  letter-spacing: 1.7px;
  font-size: 3.4rem;
  text-transform: uppercase;
  margin-bottom: 3.3rem;
  text-align: center;
`;

export const CheckboxWrapper = styled.div`
  span {
    font-weight: bold;
    font-size: 1.8rem;
    margin-left: 1.6rem;
  }

  .set {
    margin-top: 0.7rem;
    width: 44.5rem;
    height: 33.8rem;
    border: 1px solid #00000020;
    border-radius: 0.8rem;

    padding: 1rem 2.4rem;
    overflow: auto;

    margin-bottom: 6.1rem;

    ::-webkit-scrollbar {
      width: 9px;
    }

    ::-webkit-scrollbar-track {
      background: #e9e9e9;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #000;
      border-radius: 20px;
      border: 2px solid #e9e9e9;
    }

    @media (max-width: 425px) {
      width: 100%;
    }
  }

  @media (max-width: 425px) {
    width: 80%;
  }
`;

export const ModalButton = styled.button`
  width: 487px;
  height: 58px;
  background: transparent linear-gradient(96deg, #000000 0%, #232323 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;

  color: #fff;
  font-size: 2.4rem;
  font-weight: bold;

  @media (max-width: 425px) {
    width: 80%;
  }
`;

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 3.1rem;
`;

export const HeaderWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;
  margin-left: 0.6rem;
`;

export const Container = styled.div``;

export const PageHeader = styled.header`
  position: static;
  align-items: center;
  justify-content: space-between;

  padding: 3.6rem 6rem 2.8rem 6rem;

  > button {
    max-width: none;
    margin-bottom: 1rem;
  }

  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

export const ContentRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  width: 100%;
  height: 5rem;

  @media (min-width: 475px) {
    display: flex;
  }

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const InputContainer = styled.div`
  background: #fff;

  width: 100%;

  height: 5rem;
  border-radius: 8rem;

  @media (min-width: 475px) {
    display: flex;
  }

  @media (min-width: 768px) {
    max-width: 42rem;
  }

  form {
    background: #fff;
    width: 100%;
    height: 5rem;
    border-radius: 8rem;
    flex: 1;

    display: flex;
    align-items: center;
    height: 100%;

    svg {
      margin-left: 2.5rem;
      margin-right: 0.8rem;
    }

    input {
      width: 100%;
      height: 100%;
      border: 0;
      border-top-right-radius: 50%;
      border-bottom-right-radius: 50%;

      font-size: 1.7rem;
      letter-spacing: 0.85px;
      line-height: 2.1rem;
      color: #000;

      &::placeholder {
        color: #000000;
      }
    }
  }
`;

export const PageHeaderButtons = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;

  margin-left: 1rem;

  position: relative;

  > svg {
    width: 2.8rem;
    height: 2.8rem;

    border-radius: 50%;
    .a {
      fill: #000000;
    }
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 5rem;
    right: 0;

    width: 18.7rem;
    height: 3.3rem;

    background: #ffffff;
    box-shadow: 0px 3px 6px #10101087;
    border-radius: 0.3rem;
    opacity: 0;
    transition: 300ms ease-in;
    margin-top: 0.5rem;

    pointer-events: visible;

    > p {
      font-size: 1.7rem;
      letter-spacing: 0.85px;
      line-height: 2.1rem;
      color: #000;
    }
  }

  &:hover {
    background: linear-gradient(155deg, #ffdf22d1 0%, #ffd503d1 100%);

    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const CardContainer = styled.ul`
  margin: 2rem 3.1rem;
  display: grid;

  padding-bottom: 3rem;

  grid-template-columns: 1fr 1fr 1fr;

  gap: 3rem 2rem;

  @media (max-width: 1440px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    margin: 0 2rem;
  }
`;

type CheckButtonProps = {
  isSelected?: boolean;
};

export const CheckButton = styled.button.attrs({
  type: 'button',
})<CheckButtonProps>`
  margin-bottom: 0.9rem;
  background: transparent;

  display: flex;

  align-items: center;

  .radio {
    width: 2.7rem;
    height: 2.7rem;
    background: #fff;

    border: 1px solid #000;
    border-radius: 0.4rem;
  }

  .filled {
    width: 100%;
    height: 100%;
    border: 2px solid #fff;
    border-radius: 0.4rem;

    background: ${({ isSelected }) => (isSelected ? '#000' : false)};
  }

  p {
    color: #000;

    font-size: 1.8rem;
    padding: 0 0.5rem;
    text-transform: capitalize;
  }

  :active {
    filter: opacity(0.5);
  }
`;

export const CheckboxSet = styled.fieldset`
  border: none;
  padding-left: 0.5rem;

  display: flex;
  flex-direction: column;
  margin-bottom: 0.7rem;
`;

export const ModalExportReportContent = styled.div`
  width: 100%;
  max-width: 48.7rem;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ModalQuestion = styled.div`
  margin-bottom: 4.8rem;

  > h2 {
    font-weight: bold;
    font-size: 2rem;
    line-height: 1.3rem;
    color: #000000;

    text-align: center;
  }

  .radioOptions {
    display: flex;
    justify-content: center;

    margin-top: 1.3rem;
  }

  .checkboxOptions {
    width: 100%;
    max-width: 20rem;

    margin: 0 auto;
    margin-top: 2.2rem;
  }
`;

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioOption = styled.button<RadioOptionProps>`
  display: flex;
  align-items: center;
  background: none;

  & + & {
    margin-left: 3rem;
  }

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 0.8px solid #000;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#000' : '#fff')};
    }
  }

  > p {
    color: #000;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:hover {
    .radio {
      border-color: #000;
    }

    > p {
      color: #000;
    }
  }
`;

interface CheckboxProps {
  isFilled: boolean;
}

export const Checkbox = styled.div<CheckboxProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;

  border: 0.8px solid #000000;
  border-radius: 0.4rem;

  height: 2.8rem;
  min-width: 2.8rem;

  margin-right: 0.8rem;

  .filled {
    background: ${({ theme, isFilled }) =>
      isFilled ? theme.colors.black : theme.colors.white};

    height: 2.2rem;
    min-width: 2.2rem;

    border-radius: inherit;

    transition: 180ms ease-in;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;

  margin-bottom: 0.8rem;

  cursor: pointer;

  &:hover {
    ${Checkbox} {
      .filled {
        background: #000;
      }
    }
  }
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;

export const NoDataFound = styled.div`
  display: grid;
  place-items: center;

  height: 50vh;

  > h1 {
    color: #ffdf22;
  }
`;
